import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../../common_nextgen/common_components/common-hooks/useLocationState";

const useAccumulationCodeListAl2 = (
  hideModal,
  selectMode,
  lookupType,
  selectedCode,
  onNavigate
) => {
  const [data, setData] = useState([]);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const { showModal } = useModal();
  const toast = useToast();
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const [blankRecordAdded, setBlankRecordAdded] = useState(false);
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
    ACCUMULATION_CODE_LIST,
    ACCUMULATION_CODE,
  } = ROUTE_PATHS;

  //const { state: stateVal } = location;
  /*const stateVal = location.state || [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);*/
  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state ?? [],
  });
  const {
    selectedCodes = [],
    previousScreen = ACCUMULATION_CODE_LIST,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    initialParamsData = {
      al1AccumulationCodeLst:
        selectedCodes[initialIndex]?.al1AccumulationCodeLst,
      al1AccumCodeListDescr: selectedCodes[initialIndex]?.al1AccumCodeListDescr,
      acmAccumulationCode: selectedCodes[initialIndex]?.acmAccumulationCode,
    },
    externalScreenNumber = null,
    externalScreenTitle = null,
  } = currentState;

  const screen_title = externalScreenTitle ?? "Codes in Accumulation Code List";
  const screenNumber = externalScreenNumber ?? "RCAL2001";
  
  const initialQueryData = selectMode
    ? {
        al1AccumulationCodeLst: selectedCode[0]?.al1AccumulationCodeLst,
        al1AccumCodeListDescr: selectedCode[0]?.al1AccumCodeListDescr,
        acmAccumulationCode: "",
      }
    : initialParamsData;
  const [paramsData, setParamsData] = useState(initialQueryData);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);

  const formFields = [
    {
      fieldLabel: "AL1 Accumulation Code lst",
      name: "al1AccumulationCodeLst",
      label: "List",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "AL1 Accum Code List Descr",
      name: "al1AccumCodeListDescr",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "ACM Accumulation Code",
      name: "acmAccumulationCode",
      label: "Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleReceiveData = async (data) => {
    // console.log("data", data);
    const listData = {
      ...data,
      al1AccumulationCodeLst: paramsData.al1AccumulationCodeLst,
      screenNumber: screenNumber,
    };
    try {
      const { responseStatus } = await axios_helper_no_header(
        "POST",
        "api/al2AccumCodeListDtl",
        listData,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
    } catch (e) {
      console.error("There was an error selecting the data!", e);
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        e.data;
      toast.current.show({
        severity: "error",
        summary: "",
        detail: message,
        life: 3000,
      });
    } finally {
      const updatedParamsData = {
        ...paramsData,
        acmAccumulationCode: data["acmAccumulationCode"],
      };
      setParamsData(updatedParamsData);
    }
  };

  const ctaButtons = selectMode
    ? []
    : [
        ...(externalScreenNumber !== "RCAL2003" ? [{
          button_label: "Add Codes in Accumulation Code List",
          button_handeler: () => {
            // showModal({ default: "RCACM001" });
            const params = {
              lookupType: "local",
              fieldMapping: {
                default: [
                  {
                    source: "acmAccumulationCode",
                    target: "acmAccumulationCode",
                  },
                ],
              },
            };
            showModal({ default: "RCACM001" }, { params }, handleReceiveData);
            // navigateToPage(ACCUMULATION_CODE, [...previousState, { ...currentState, currentIndex, paramsData }, { selectedCodesListItem: paramsData.al1AccumulationCodeLst, previousScreen: location.pathname, selectMode: true }]);
          },
          button_key: "F6",
        },
        {
          button_label: "Add Blank Code",
          button_handeler: () => {
            addBlankAccumulationCodes();
          },
          button_key: "F10",
        }] : []),
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
        // {
        //   button_label: "Back",
        //   button_handeler: () => {
        //     navigateToPage(DISPLAY_PRICE_SCHEDULE);
        //   },
        //   button_key: "F12",
        // },
      ];

  const addBlankAccumulationCodes = async () => {
    const data = {
      al1AccumulationCodeLst: paramsData.al1AccumulationCodeLst,
      acmAccumulationCode: "",
    };

    try {
      const { responseStatus } = await axios_helper_no_header(
        "POST",
        "api/al2AccumCodeListDtl",
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      setBlankRecordAdded(true);
    } catch (e) {
      console.error("There was an error selecting the data!", e);
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        e.data;
      toast.current.show({
        severity: "error",
        summary: "",
        detail: message,
        life: 3000,
      });
    }
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedCodes.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];
  const menuOptions = selectMode
    ? []
    : [
        ...(externalScreenNumber !== "RCAL2003" ? [{
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        }] : []),
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            validateBeforeDisplay();
          },
        },
      ];

  const columnDef = [
    {
      header: "Code",
      field: "acmAccumulationCode",
    },
    {
      header: "Description",
      field: "acmDesc",
    },
  ];

  const parmKey = "acmAccumulationCode";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const { al1AccumulationCodeLst, acmAccumulationCode } = paramsData;
      const raw_response = await axios_helper_no_header(
        "GET",
        "api/al2AccumCodeListDtl",
        null,
        {
          page: page,
          size: rows,
          al1AccumulationCodeLst,
          acmAccumulationCode,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    const hasParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.al1AccumulationCodeLst;
    if (hasParams) fetchData();
  }, [paramsData, rows, currentPage, blankRecordAdded]);

  useEffect(() => {
    if (currentIndex != initialIndex) {
      setParamsData({
        al1AccumulationCodeLst:
          selectedCodes[currentIndex].al1AccumulationCodeLst,
        al1AccumCodeListDescr:
          selectedCodes[currentIndex].al1AccumCodeListDescr,
        acmAccumulationCode: "",
      });
    }
  }, [currentIndex]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      //   const params = { acmAccumulationCode: rowData[parmKey] };
      console.log({ acmAccumulationCode: rowData[parmKey] }, "agam");
      axios_helper_no_header("DELETE", "api/al2AccumCodeListDtl", null, {
        ...paramsData,
        acmAccumulationCode: rowData[parmKey],
      })
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          fetchData();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/al2AccumCodeListDtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const validateBeforeDisplay = () => {
    axios_helper_no_header(
      "GET",
      "api/al2AccumCodeListDtl/validateBeforeDisplay",
      {},
      { ...paramsData, acmAccumulationCode: rowData[parmKey] }
    )
      .then((response) => {
        console.log("navigating to display", response);
        navigateToPage(ROUTE_PATHS.ACCUMULATION_CODE_DISPLAY, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCodes: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  useEffect(() => {
    if (
      !paramsData.al1AccumulationCodeLst &&
      initialParamsData.al1AccumulationCodeLst
    ) {
      setParamsData(initialParamsData);
    }
  }, [initialParamsData]);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
  };
};

export default useAccumulationCodeListAl2;
